import Link from "next/link";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaPlay } from "react-icons/fa";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { useState } from "react";

function AboutHomeSection({ sectionSpace }) {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="X7R-q9rsrtU"
        onClose={() => setOpen(false)}
      />
      <div className={`ltn__about-us-area ${sectionSpace}`}>
        <Container>
          <Row>
            <Col xs={12} lg={6} className="align-self-stretch">
              <div
                className="about-us-img-wrap about-img-left"
                style={{ height: "100%" }}
              >
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="none"
                  loading="lazy"
                  poster="/img/gallery/home-why-choose-one.webp"
                  aria-label="Siddhivinayak Embassy-10 — premium 2 and 3 BHK flats in Hanuman Nagar, Nagpur — walkthrough video"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                >
                  <source src="/media/embassy-10.mp4" type="video/mp4" />
                  <track kind="captions" src="/media/captions-empty.vtt" srclang="en" label="No captions available" default />
                </video>
              </div>
            </Col>
            <Col xs={12} lg={6} className="align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area mb-20">
                  <span className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    About Us
                  </span>
                  <h2 className="section-title">
                    Nagpur&apos;s Most Trusted Real Estate Developer<span>.</span>
                  </h2>
                  <p>
                    Siddhivinayak Group, a distinguished venture of the Kunal Padole Group, embodies enduring trust, transparency, and excellence in real estate development in Nagpur. Each project is thoughtfully planned with meticulous precision, delivering a refined customer experience,{" "}
                    <Link href="/projects">premium living spaces</Link>, and long-term investment value.
                  </p>
                  <p>Driven by innovation, modern architecture, disciplined execution, and high-quality construction, we have earned our position as a <Link href="/about">trusted real estate developer in Nagpur</Link>.</p>
                  <p>As Nagpur advances toward becoming India's future Smart City, supported by transformative infrastructure developments, our strategically located residential and commercial properties in Nagpur ensure seamless connectivity and easy access to essential daily conveniences.</p>
                </div>
                <ul className="ltn__list-item-half clearfix">
                  <li>
                    <i className="flaticon-home-2"></i>
                    Enduring Trust &amp; Transparency
                  </li>
                  <li>
                    <i className="flaticon-mountain"></i>
                    Contemporary Architecture
                  </li>
                  <li>
                    <i className="flaticon-heart"></i>
                    Superior Construction Quality
                  </li>
                  <li>
                    <i className="flaticon-secure"></i>
                    Smart City Location
                  </li>
                </ul>

                <div className="btn-wrapper animated">
                  <Link
                    href="/about"
                    className="theme-btn-1 btn btn-effect-1"
                  >
                    Learn more about Siddhivinayak Group
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AboutHomeSection;
